// export const baseUrl = "http://localhost/Farah/farah/public";
// export const baseUrl = "http://127.0.0.1:8000";
export const baseUrl = "https://farahnilecruise.com/backend";
